import React from 'react';
import RptClasswiseFS from './Rpt_Classwise_FS';
import '../../../CommonCSS/SocietyCSS.css'

const RptClassFSApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Classwise Fees Structure</h5>
          </div>
        </div>
        <RptClasswiseFS />
      </div>
    </div >
  );
};

export default RptClassFSApp;
